<template>
  <section>
    <h3 v-if="title" class="mb-2 text-xs uppercase">{{ title }}</h3>
    <dl class="section-list grid gap-px overflow-hidden rounded-md">
      <slot />
    </dl>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  title?: string
}>()
</script>

<style scoped lang="scss">
.section-list {
  border: 1px solid var(--color-border-muted);
}
</style>
